import { EventEmitter, Injectable, Injector } from '@angular/core';
import { BaseService } from './shared/services/base.service';
import { ApiResponse, AuthState } from './shared/models/common.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService extends BaseService {
  constructor(injector: Injector) {
    super(injector);
  }
  readonly balanceUpdate = new EventEmitter<void>();
  storeData$ = new BehaviorSubject<AuthState | null>(null);

  logOut() {
    return this.http.get(`${this.apiUrl}auth/logout`, this.httpOptions);
  }

  getMenuContent(){
    return this.http.get(`${this.apiUrl}public/supporter/sidebar-content`, this.httpOptions);
  }

  getClubUrl(club_id){
    return this.http.get(`${this.apiUrl}public/club/primary-info/${club_id}`, this.httpOptions);
  }

  totalBalance(): Observable<ApiResponse<{ balance: number }>>{
    // @ts-ignore
    return this.http.get(`${this.apiUrl}public/supporter/total-balance`, this.httpOptions);
  }

    getIpAddress() {
    return this.http.get('https://api.ipify.org?format=json');
  }

}
